/* eslint-disable array-callback-return */
import React, { Component } from 'react'
import { Spinner } from 'react-bootstrap-v5'
import { postRequestOptions } from '../helpers/Fetchwrapper'
import { BiChevronLeft, BiChevronRight, BiChevronsLeft, BiChevronsRight, BiSortDown, BiSortUp } from "react-icons/bi";
import { KTSVG } from '../../_metronic/helpers';

// Rows per page to choose from; the first is the default and the smallest a page may ask for.
const PER_PAGE_OPTIONS = [50, 500, 1000, 2000, 5000, 10000];

class DataTable extends Component {
	constructor(props) {
		super(props)

		this.state = {
			entities: {
				data: [],
				current_page: 1,
				from: 1,
				last_page: 1,
				per_page: Math.max(PER_PAGE_OPTIONS[0], Number(this.props.defaultPerPage) || PER_PAGE_OPTIONS[0]),
				to: 1,
				total: 1,
			},
			first_page: 1,
			current_page: 1,
			sorted_column: this.props.defaultSortedColumn !== undefined ? this.props.defaultSortedColumn : this.props.columns[0].value,
			offset: 4,
			order: this.props.defaultSortOrder !== undefined ? this.props.defaultSortOrder : 'DESC',
			/*new obj*/
			limit: '10',
			// offset: 0,
			globalSearch: '',
			columns: this.props.filters,
			additionalPostData: this.props.additionalPostData !== undefined ? this.props.additionalPostData : null
		}
	}

	componentDidUpdate(prevProps) {
		if ((this.props.newData !== undefined && (this.props.newData.id !== prevProps.newData.id)) || (this.props.additionalPostData !== undefined && (this.props.additionalPostData !== prevProps.additionalPostData))) {
			this.setState({ current_page: this.state.entities.current_page, loading: true, additionalPostData: this.props.additionalPostData !== undefined ? this.props.additionalPostData : null }, () => {
				this.fetchEntities()
			})
		}
	}

	fetchEntities() {
		this.setState({ loading: true })
		let fetchUrl = `${this.props.url}?page=${this.state.current_page}&column=${this.state.sorted_column}&order=${this.state.order}&globalSearch=${this.state.globalSearch}&per_page=${this.state.entities.per_page}`
		const requestOptions = postRequestOptions(this.state);

		fetch(fetchUrl, requestOptions)
			.then((resp) => {
				return resp.json()
			})
			.then((response) => {
				this.setState({ entities: response.data.data, loading: false })
			})
			.catch((error) => {
				this.setState({ loading: false })
				console.log(error, 'catch the hoop')
			})
	}

	changePage(pageNumber) {
		this.setState({ current_page: pageNumber }, () => {
			this.fetchEntities()
		})
	}

	changePerPage = (evt) => {
		this.setState({ entities: { ...this.state.entities, per_page: evt.target.value } }, () => {
			this.fetchEntities()
		})
	}

	changeGlobalSearch = (evt) => {
		this.setState({
			globalSearch: evt.target.value
		},
			() => {
				this.fetchEntities();
				if (this.props.onValueChange) {
					this.props.onValueChange(this.state);
				}
			}
		)
	}

	columnsFilterChange = (evt) => {
		const inputName = evt.target.name
		let columnKey = inputName
		let valueField = 'filterValue'

		if (inputName.endsWith('From')) {
			columnKey = inputName.slice(0, -4)
			valueField = 'filterValueFrom'
		} else if (inputName.endsWith('To')) {
			columnKey = inputName.slice(0, -2)
			valueField = 'filterValueTo'
		}

		const columnConfig = (this.props.columns || []).find((column) => column.value === columnKey)
		const previousColumnFilter = this.state.columns[columnKey] || {}
		let filterType = 'like'

		if (columnConfig?.filterType === 'dateRange') {
			filterType = 'between'
		} else if (columnConfig?.filterType === 'select' || columnConfig?.filterType === 'date') {
			filterType = '='
		}

		const nextColumnFilter = {
			...previousColumnFilter,
			filterType,
			[valueField]: evt.target.value,
		}

		if (columnConfig?.filterType === 'dateRange') {
			const fromValue = valueField === 'filterValueFrom' ? evt.target.value : (previousColumnFilter.filterValueFrom || '')
			const toValue = valueField === 'filterValueTo' ? evt.target.value : (previousColumnFilter.filterValueTo || '')
			// Keep a non-empty sentinel so backends that skip blank filterValue still receive range filters
			nextColumnFilter.filterValue = fromValue || toValue || ''
			nextColumnFilter.filterValueFrom = fromValue
			nextColumnFilter.filterValueTo = toValue
		}

		this.setState(
			{
				columns: {
					...this.state.columns,
					[columnKey]: nextColumnFilter,
				},
			},
			() => {
				this.fetchEntities();
				if (this.props.onValueChange) {
					this.props.onValueChange(this.state);
				}
			}
		)
	}

	columnHead(value) {
		return value.split('_').join(' ')
	}

	/**
	 * Where a column's text sits, unless the column gives its own `align`:
	 * centre for actions, statuses, ids and dates; right for amounts (a name like amount, rate or qty,
	 * or every value on the page a number: "1,250.50", "-3", "(40)", "12%"); left for everything else.
	 */
	columnAlign(column) {
		if (column.align) {
			return column.align
		}

		const name = String(column.value || '')
		const title = String(column.title || '')
		const values = (this.state.entities.data || [])
			.map((row) => row[column.value])
			.filter((value) => value !== null && value !== undefined && value !== '')
		const every = (test) => values.length > 0 && values.every((value) => test(String(value).trim()))

		if (column.hasActionsComponent || name === 'action') {
			return 'center'
		}
		if (/status/i.test(name) || /status/i.test(title)) {
			return 'center'
		}
		// id, idSalesOrders, id_sr, invoiceId, salesOrderID, or a title like "ID" / "Order ID"
		if (/^id($|[A-Z_])|(Id|ID|_id)$/.test(name) || /\bid\b/i.test(title)) {
			return 'center'
		}
		// invoiceDate, created_at, createdAt, or values like 2026-10-15, 2026-10-15 14:53:52, 15-10-2026, 15 Oct 2026
		if (/date/i.test(name) || /date/i.test(title) || /(At|_at)$/.test(name)
			|| every((value) => /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}(:\d{2})?)?$|^\d{1,2}[-/ ](\d{1,2}|[A-Za-z]{3})[-/ ]\d{2,4}$/.test(value))) {
			return 'center'
		}
		// Amounts: every value a number, or an amount-like name on a column without text
		// (its value made by the page, or numbers), so "paymentType: Paid" stays left.
		const isNumber = (value) => /^\(?-?[\d,]*\.?\d+\)?%?$/.test(value)
		const hasText = values.some((value) => !isNumber(String(value).trim()))
		if (every(isNumber)
			|| (!hasText && /amount|rate|price|cost|total|balance|qty|quantity|payment|due|paid|discount|vat|tax/i.test(name))) {
			return 'right'
		}

		return 'left'
	}

	// The column's style with its alignment; numbers stay on one line with digits of equal width.
	columnStyle(column, align) {
		return align === 'right'
			? { ...column.style, textAlign: align, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }
			: { ...column.style, textAlign: align }
	}

	pagesNumbers() {
		if (!this.state.entities.to) {
			return []
		}
		let from = this.state.entities.current_page - this.state.offset
		if (from < 1) {
			from = 1
		}
		let to = from + this.state.offset * 2
		if (to >= this.state.entities.last_page) {
			to = this.state.entities.last_page
		}
		let pagesArray = []

		for (let page = from; page <= to; page++) {
			pagesArray.push(page)
		}
		return pagesArray
	}

	componentDidMount() {
		this.setState({ current_page: this.state.entities.current_page, loading: true }, () => {
			this.fetchEntities()
		})
	}

	tableHeads(aligns) {
		let icon
		if (this.state.order === 'asc') {
			icon = <BiSortUp className='ms-1 flex-shrink-0' size={16}></BiSortUp>
		} else {
			icon = <BiSortDown className='ms-1 flex-shrink-0' size={16}></BiSortDown>
		}
		return this.props.columns.map((column, index) => {
			const style = this.columnStyle(column, aligns[index])
			if (column.value === 'action') {
				return (
					<th style={style} key={index}>
						{column.title}
					</th>
				)
			} else {
				return (
					<th
						style={style}
						className='cursor-pointer'
						key={index}
						onClick={() => this.sortByColumn(column.value)}
					>
						<span className='d-inline-flex align-items-center'>
							{this.columnHead(column.title)}
							{column.value === this.state.sorted_column && icon}
						</span>
					</th>
				)
			}
		})
	}

	tableHeadFilter() {
		return this.props.columns.map((column, index) => {
			if (column.value === 'action' || column.hideFilter) {
				return <td key={index}></td>
			}

			if (column.filterType === 'select' && Array.isArray(column.filterOptions)) {
				return (
					<td key={index}>
						<select
							name={column.value}
							value={this.state.columns[column.value]?.filterValue ?? ''}
							onChange={this.columnsFilterChange}
							className='form-select form-select-sm'
							style={{ borderColor: '#e4e6ef' }}
						>
							<option value=''>{column.filterPlaceholder || 'Select'}</option>
							{column.filterOptions.map((option) => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</select>
					</td>
				)
			}

			if (column.filterType === 'dateRange') {
				return (
					<td key={index} style={{ minWidth: '150px' }}>
						<div className='d-flex flex-column gap-1'>
							<input
								type='date'
								name={`${column.value}From`}
								value={this.state.columns[column.value]?.filterValueFrom ?? ''}
								onChange={this.columnsFilterChange}
								className='form-control form-control-sm'
								style={{ borderColor: '#e4e6ef' }}
								title='From date'
								placeholder='From'
							/>
							<input
								type='date'
								name={`${column.value}To`}
								value={this.state.columns[column.value]?.filterValueTo ?? ''}
								onChange={this.columnsFilterChange}
								className='form-control form-control-sm'
								style={{ borderColor: '#e4e6ef' }}
								title='To date'
								placeholder='To'
							/>
						</div>
					</td>
				)
			}

			return (
				<td key={index}>
					<input
						type={column.filterType === 'date' ? 'date' : 'text'}
						name={column.value}
						value={this.state.columns[column.value]?.filterValue ?? ''}
						onChange={this.columnsFilterChange}
						className='form-control form-control-sm'
						style={{ borderColor: '#e4e6ef' }}
						placeholder={column.filterPlaceholder || ''}
					/>
				</td>
			)
		})
	}

	dataList(aligns) {
		if (this.state.entities?.data?.length) {
			return this.state.entities.data.map((value, key) => {
				return (
					<tr key={key}>
						{this.props.columns.map((column, index) => {
							const style = this.columnStyle(column, aligns[index])
							// if (column.value !== 'action') {
							// 	return (
							// 		<td style={column.style} key={index}>
							// 			{value[column.value]}
							// 		</td>
							// 	)
							// } else {
							// 	return (
							// 		<td style={column.style} key={value[this.props.columns[0].value] + index}>
							// 			{column.actionsComponent(value)}
							// 		</td>
							// 	)
							// }
							if (column.hasActionsComponent !== undefined && column.hasActionsComponent === true) {
								return (
									<td style={style} key={value[this.props.columns[0].value] + index}>
										{column.actionsComponent(value)}
									</td>
								)
							}
							else if (column.hasHtmlComponent !== undefined && column.hasHtmlComponent === true) {
								return (
									<td style={style} key={value[this.props.columns[0].value] + index}>
										{column.htmlComponent(value)}
									</td>
								)
							}
							else {
								return (
									<td style={style} key={index}>
										{value[column.value]}
									</td>
								)
							}
						})}
					</tr>
				)
			})
		} else {
			return (
				<tr>
					<td colSpan={this.props.columns.length} className='text-center'>
						No Records Found.
					</td>
				</tr>
			)
		}
	}

	sortByColumn(column) {
		const { sorted_column, order, first_page } = this.state;

		// Determine new sorting order
		let newOrder = order;
		if (column === sorted_column) {
			newOrder = order === 'asc' ? 'desc' : 'asc';
		} else {
			newOrder = 'asc';
		}

		// Update state and fetch entities
		this.setState(
			{
				sorted_column: column,
				order: newOrder,
				current_page: column === sorted_column ? this.state.current_page : first_page
			},
			() => {
				this.fetchEntities();
				if (this.props.onValueChange) {
					this.props.onValueChange(this.state);
				}
			}
		);


		// if (column === this.state.sorted_column) {
		// 	this.state.order === 'asc'
		// 		? this.setState({ order: 'desc', current_page: this.state.first_page }, () => {
		// 			this.fetchEntities()
		// 		})
		// 		: this.setState({ order: 'asc' }, () => {
		// 			this.fetchEntities()
		// 		})
		// } else {
		// 	this.setState(
		// 		{ sorted_column: column, order: 'asc', current_page: this.state.first_page },
		// 		() => {
		// 			this.fetchEntities()
		// 		}
		// 	)
		// }
	}

	pageList() {
		return this.pagesNumbers().map((page) => {
			return (
				<li
					className={page === this.state.entities.current_page ? 'page-item active' : 'page-item'}
					key={page}
				>
					<button className='page-link' onClick={() => this.changePage(page)}>
						{page}
					</button>
				</li>
			)
		})
	}

	// A First / Previous / Next / Last button: greyed out when it would not change the page.
	pageStep(className, page, disabled, title, content) {
		return (
			<li className={`page-item ${className}${disabled ? ' disabled' : ''}`} title={title}>
				<button className='page-link' disabled={disabled} aria-label={title} onClick={() => this.changePage(page)}>
					{content}
				</button>
			</li>
		)
	}

	exportData = () => {
		let currentData = [];
		let headersTitle = [];

		this.props.columns.map((column) => {
			if (!column.hasActionsComponent) {
				headersTitle.push(column.title);
			}
		});
		currentData.push(headersTitle);
		this.state.entities.data.map((value) => {
			var rows = [];
			this.props.columns.map((column, index) => {
				if (!column.hasActionsComponent) {
					rows.push(value[column.value]);
				}
			});
			currentData.push(rows);
		})
		this.exportToCsv('My Data.csv', currentData);
	}

	exportToCsv = (filename, rows) => {
		var processRow = function (row) {
			var finalVal = '';
			for (var j = 0; j < row.length; j++) {
				var innerValue = row[j] === null || row[j] === undefined ? '' : row[j].toString();
				if (row[j] instanceof Date) {
					innerValue = row[j].toLocaleString();
				};
				var result = innerValue.replace(/"/g, '""');
				if (result.search(/("|,|\n)/g) >= 0)
					result = '"' + result + '"';
				if (j > 0)
					finalVal += ',';
				finalVal += result;
			}
			return finalVal + '\n';
		};

		var csvFile = '';
		for (var i = 0; i < rows.length; i++) {
			csvFile += processRow(rows[i]);
		}

		var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
		var link = document.createElement("a");
		if (link.download !== undefined) {
			// Browsers that support HTML5 download attribute
			var url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", filename);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}

	render() {
		const { data, current_page, last_page, per_page, total } = this.state.entities;
		const hasData = data && data.length > 0;
		// Rows shown, as the paginator gives them; counted from the page for answers without them.
		const from = this.state.entities.from || (current_page - 1) * per_page + 1;
		const to = this.state.entities.to || from + (hasData ? data.length : 0) - 1;
		const isFirstPage = current_page <= 1;
		const isLastPage = current_page >= last_page;
		const count = (value) => Number(value || 0).toLocaleString('en-US');
		const aligns = this.props.columns.map((column) => this.columnAlign(column));

		return (
			<>
				{/* Three zones of equal width so the pages sit in the middle: page size and count,
				    pages, search and download. Below xl the pages move under the other two. */}
				<div className='row g-3 align-items-center mb-4'>
					<div className='col-6 col-xl-3 order-1 d-flex align-items-center gap-3'>
						<select
							className='form-select form-select-sm dt-toolbar-input dt-page-size'
							value={this.state.entities.per_page}
							onChange={this.changePerPage}
							style={{ width: 'auto' }}
							title='Rows per page'
						>
							{!PER_PAGE_OPTIONS.includes(Number(this.state.entities.per_page)) && (
								<option value={this.state.entities.per_page}>{count(this.state.entities.per_page)}</option>
							)}
							{PER_PAGE_OPTIONS.map((size) => (
								<option key={size} value={size}>{count(size)}</option>
							))}
						</select>
						{hasData && (
							<span className='text-muted fs-7 text-nowrap'>
								Showing <span className='fw-bolder text-gray-800'>{count(from)}–{count(to)}</span> of <span className='fw-bolder text-gray-800'>{count(total)}</span>
							</span>
						)}
					</div>
					<div className='col-12 col-xl-6 order-3 order-xl-2 d-flex justify-content-center'>
						{hasData && (
							<nav aria-label='Pages'>
								<ul className='pagination dt-pagination mb-0'>
									{this.pageStep('previous', 1, isFirstPage, 'First page', <BiChevronsLeft size={16} />)}
									{this.pageStep('previous', current_page - 1, isFirstPage, 'Previous page', <BiChevronLeft size={16} />)}
									{this.pageList()}
									{this.pageStep('next', current_page + 1, isLastPage, 'Next page', <BiChevronRight size={16} />)}
									{this.pageStep('next', last_page, isLastPage, `Last page (${count(last_page)})`, <BiChevronsRight size={16} />)}
								</ul>
							</nav>
						)}
					</div>
					<div className='col-6 col-xl-3 order-2 order-xl-3 d-flex justify-content-end align-items-center gap-2'>
						<div className='position-relative' style={{ maxWidth: '260px', width: '100%' }}>
							<KTSVG path='/media/svg/icons/General/Search.svg' className='svg-icon-3 svg-icon-gray-500 position-absolute dt-search-icon top-50 translate-middle-y ms-3' />
							<input
								type='text'
								placeholder='Search'
								value={this.state.globalSearch}
								onChange={this.changeGlobalSearch}
								className='form-control form-control-sm dt-toolbar-input ps-10'
							/>
						</div>
						<button className='btn btn-sm btn-icon btn-light-primary' title='Download CSV' onClick={this.exportData} disabled={!hasData}>
							<KTSVG path='/media/svg/icons/Files/Download.svg' className='svg-icon-3' />
						</button>
					</div>
				</div>
				<div className='table-responsive'>
					<table className='table table-sm table-hover table-striped table-bordered dt-compact'>
						<thead>
							<tr>{this.tableHeads(aligns)}</tr>
							<tr className='dt-filters'>{this.tableHeadFilter()}</tr>
						</thead>
						<tbody>
							{this.state.loading ? (
								<tr>
									<td colSpan={this.props.columns.length} className='text-center'>
										{' '}
										<Spinner animation='grow' />
										<Spinner animation='grow' />
										<Spinner animation='grow' />
									</td>
								</tr>
							) : (
								this.dataList(aligns)
							)}
						</tbody>
					</table>
				</div>

			</>
		)
	}
}

export default DataTable